import Todo from "./Componend/Todo";

function App() {
  return (
    <div>
      <Todo />
    </div>
  );
}

export default App;
